import axios from 'axios';
import { baseURL } from '../config';

// Get subscription status for all symbols
export const getSubscriptionStatus = async (token) => {
    try {
        const response = await axios.get(`${baseURL}/api/symbol-subscriptions/status`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching subscription status:', error);
        throw error;
    }
};

// Subscribe to a specific symbol
export const subscribeToSymbol = async (token, symbolId) => {
    try {
        console.log('Subscribing to symbol ID:', symbolId);
        console.log('API URL:', `${baseURL}/api/symbol-subscriptions/${symbolId}/subscribe`);
        
        const response = await axios.post(`${baseURL}/api/symbol-subscriptions/${symbolId}/subscribe`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        console.log('Subscribe response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error subscribing to symbol:', error);
        console.error('Error details:', error.response?.data);
        console.error('Error status:', error.response?.status);
        console.error('Error URL:', error.config?.url);
        
        // Try alternative endpoint format if the first one fails
        if (error.response?.status === 404) {
            console.log('Trying alternative endpoint format...');
            try {
                const altResponse = await axios.post(`${baseURL}/api/symbols/${symbolId}/subscribe`, {}, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                console.log('Alternative subscribe response:', altResponse.data);
                return altResponse.data;
            } catch (altError) {
                console.error('Alternative endpoint also failed:', altError);
                throw error; // Throw original error
            }
        }
        
        throw error;
    }
};

// Unsubscribe from a specific symbol
export const unsubscribeFromSymbol = async (token, symbolId) => {
    try {
        console.log('Unsubscribing from symbol ID:', symbolId);
        console.log('API URL:', `${baseURL}/api/symbol-subscriptions/${symbolId}/unsubscribe`);
        
        const response = await axios.post(`${baseURL}/api/symbol-subscriptions/${symbolId}/unsubscribe`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        console.log('Unsubscribe response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error unsubscribing from symbol:', error);
        console.error('Error details:', error.response?.data);
        console.error('Error status:', error.response?.status);
        console.error('Error URL:', error.config?.url);
        
        // Try alternative endpoint format if the first one fails
        if (error.response?.status === 404) {
            console.log('Trying alternative endpoint format...');
            try {
                const altResponse = await axios.post(`${baseURL}/api/symbols/${symbolId}/unsubscribe`, {}, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                console.log('Alternative unsubscribe response:', altResponse.data);
                return altResponse.data;
            } catch (altError) {
                console.error('Alternative endpoint also failed:', altError);
                throw error; // Throw original error
            }
        }
        
        throw error;
    }
};

// Subscribe to all symbols for a specific LP
export const subscribeToAllSymbols = async (token, lpId) => {
    try {
        const response = await axios.post(`${baseURL}/api/symbol-subscriptions/lp/${lpId}/subscribe`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error subscribing to all symbols:', error);
        throw error;
    }
};

// Unsubscribe from all symbols for a specific LP
export const unsubscribeFromAllSymbols = async (token, lpId) => {
    try {
        const response = await axios.post(`${baseURL}/api/symbol-subscriptions/lp/${lpId}/unsubscribe`, {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error unsubscribing from all symbols:', error);
        throw error;
    }
};
